import { render, staticRenderFns } from "./PaginationCompat.vue?vue&type=template&id=563dca3a&"
import script from "./PaginationCompat.vue?vue&type=script&lang=js&"
export * from "./PaginationCompat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports